module.exports = __webpack_public_path__ + "static/media/mail-white.c126047e.svg";